import axiosInstance from './axiosInstance';
import { sellerService } from './seller.service';
import { sellerNotificationsService } from './sellerNotifications.service';

function extractPaginationTotal(data: {
  pagination?: { total?: number };
  total?: number;
  count?: number;
}): number {
  if (typeof data?.pagination?.total === 'number') return data.pagination.total;
  if (typeof data?.total === 'number') return data.total;
  if (typeof data?.count === 'number') return data.count;
  return 0;
}

/** Lightweight ops counters for owner / staff avatar badge. */
export async function fetchStaffNavbarBadgeCount(): Promise<number> {
  const [failedPaymentsRes, printBacklogRes, returnQueueRes] = await Promise.all([
    axiosInstance.get('/admin/orders', {
      params: { page: 1, limit: 1, paymentStatus: 'FAILED' },
    }),
    axiosInstance.get('/admin/orders', {
      params: { page: 1, limit: 1, status: 'QUEUED_FOR_PRINT' },
    }),
    axiosInstance.get('/admin/return-requests/queue', { params: { limit: 1 } }),
  ]);

  return (
    extractPaginationTotal(failedPaymentsRes.data) +
    extractPaginationTotal(printBacklogRes.data) +
    extractPaginationTotal(returnQueueRes.data)
  );
}

/** Pending seller work — orders awaiting action or unread notifications. */
export async function fetchSellerNavbarBadgeCount(): Promise<number> {
  const [summary, unread] = await Promise.all([
    sellerService.getDashboardSummary().catch(() => null),
    sellerNotificationsService.unreadCount().catch(() => 0),
  ]);
  const pendingOrders = summary?.pendingOrders ?? 0;
  return Math.max(pendingOrders, unread);
}
